import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { ActiveIngredientFilterSettingsModel } from "../../../models/activeIngredient/activeIngredientFilterSettingsModel";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';

interface IProps {
    onSearchClick: any,
    totalRecordsCount: number
}

interface IState {
    activeIngredientSettings: ActiveIngredientFilterSettingsModel,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class ActiveIngredientFilter extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props);
        this.state = {
            activeIngredientSettings: new ActiveIngredientFilterSettingsModel(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (letter: string) => {
        const currentSettings: ActiveIngredientFilterSettingsModel = { ...this.state.activeIngredientSettings };
        currentSettings.activeIngredienName = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            activeIngredientSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: ActiveIngredientFilterSettingsModel = { ...this.state.activeIngredientSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            activeIngredientSettings: { ...currentSettings },
            filterText: fiterText
        });
    }

    generateFilterText = (settings: ActiveIngredientFilterSettingsModel) => {
        let result = '';

        if (settings.alphaIndex) {
            result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.activeIngredienName) {
            result += "Name <strong>'" + settings.activeIngredienName + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            activeIngredientSettings: new ActiveIngredientFilterSettingsModel(),
            filterText: ''
        });
        this.handleSearchButtonClick(new ActiveIngredientFilterSettingsModel());
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.activeIngredientSettings)
        }
    }

    render() {
        return (
            <Toolbar style={{ marginBottom: '10px' }}>
                <AlphabeticalFilter
                    handleAlphaIndexChange={this.handleAlphaIndexChange}
                    filters={['en', 'bg']}
                />
                <div>
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="activeIngredienName"
                        placeholder="Name"
                        onChange={this.handleChange}
                        value={this.state.activeIngredientSettings && this.state.activeIngredientSettings.activeIngredienName ? this.state.activeIngredientSettings.activeIngredienName : ''}
                    />
                </div>
                <div>
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        Result: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                    <div style={{ float: "right" }}>
                        <div>
                            <Button
                                className="p-button-raised"
                                icon="pi pi-filter"
                                style={{ marginRight: "10px" }}
                                label="Filter"
                                onClick={() => this.handleSearchButtonClick(this.state.activeIngredientSettings)}
                            />
                            <Button
                                className="p-button-secondary p-button-raised"
                                label="Clear"
                                icon="pi pi-times"
                                onClick={() => this.handleClearButtonClick()}
                            />
                        </div>
                    </div>
                </div>
            </Toolbar>
        )
    }
}

export default ActiveIngredientFilter;
